// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pb-nav {
  background-color: white;
}

.my-toolbar {
  --background: var(--ion-color-primary-contrast);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filter-module/filter-menu/filter-menu.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAEA;EACI,+CAAA;AACJ","sourcesContent":[".pb-nav {\n    background-color: white;\n}\n\n.my-toolbar {\n    --background: var(--ion-color-primary-contrast);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
